import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCommentaryParamsModal = defineStore('commentaryParamsModal', () => {
  const isModalOpen = ref(false)

  return {
    isModalOpen
  }
})
